<template>
  <div class="Pppoinput">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
    
      <v-icon class="snackIcon">{{snackbar.icon}}</v-icon>

      {{ snackbar.message }}
    </v-snackbar>
    <v-form ref="formtetapkanpppo">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                :items="lookupnegeri"
                item-text="negeri"
                item-value="negeriID"
                v-model="paparppponegeri"
                :disabled="disablenegeri"
                v-on:change="paparpppo"
              ></v-autocomplete>
            </v-col>
          <v-col cols="12" md="4">
            <v-select
              outlined
              dense
              :items="senaraipegawaipp"
              v-model="setpegawaiprosesan"
              v-bind:label="$t('penyeliaprosesan')"
              item-text="nama"
              item-value="id"
              :rules="[required('penyeliaprosesan')]"
              item-disabled="disabled"
              :disabled="disablesetpegawaiprosesan"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              outlined
              dense
              :items="senaraipegawaipo"
              v-model="setpegawaioperasi"
              v-bind:label="$t('penyeliaoperasi')"
              item-text="nama"
              item-value="id"
              :rules="[required('penyeliaoperasi')]"
              item-disabled="disabled"
              :disabled="disablesetpegawaioperasi"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-row>
        <v-col cols="12" sm="12">
          <v-col class="text-right">
            <v-btn color="light-blue white--text" @click="hantarpppo"
              >{{ $t("pilih") }}
              <v-icon dark right> mdi-checkbox-marked-circle </v-icon></v-btn
            >
            &nbsp;
            <v-btn v-show="paparbtntutup" color="red accent-4 white--text" @click="tutuppppomodal"
              >{{ $t("tutup") }}
            <v-icon dark right> mdi-close-circle</v-icon></v-btn
            >
          </v-col>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import i18n from "@/i18n";
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
export default {
  name: "Pppoinput",
  components: {},
  data: () => ({
    snackbar: "",
    paparppponegeri: "",
    disablenegeri: false,
    paparnegeriexport: false,
    lookupnegeri: [],
    paparbtntutup: false,
    right: null,
    senaraipegawaipp: [],
    senaraipegawaipo: [],
    setpegawaiprosesan: "",
    setpegawaioperasi: "",
    localstoragepp: "",
    localstoragepo: "",
    disablesetpegawaiprosesan: false,
    disablesetpegawaioperasi: false,
    required(text) {
      return (v) =>
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
    },
    rules: {},
  }),
  beforeMount() {},
  mounted() {
    // this.senaraipppo()
    this.permulaan()
    console.log(this.$route.path)
  },
  methods: {
    async permulaan(){
      this.semakpppo()
      let negeri = await negerilookup.getNegeri();
      const Negeri = [];
      negeri.data.data.forEach(async function (element) {
        if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
          Negeri.push({
            negeriID: `${element.negeriID}`,
            negeri: `${element.negeri}`,
          });
        }
      });
      this.lookupnegeri = Negeri
      this.peranan = JSON.parse(window.localStorage.getItem('user'))
      console.log(this.peranan)
      if(this.peranan.role !== 'ADMIN'){
        this.senaraipppo()
        this.disablenegeri = true
        this.paparppponegeri = this.peranan.kodneg
      } else {
        this.disablesetpegawaiprosesan = true
        this.disablesetpegawaioperasi = true
        if(this.peranan === '20'){
          this.paparppponegeri = ''
        } else { 
          this.paparppponegeri = this.peranan.kodneg
          this.disablesetpegawaiprosesan = false
          this.disablesetpegawaioperasi = false
          this.senaraipppo(this.peranan.kodneg)
        }
      }
    },
    async paparpppo(){
      this.senaraipppo(this.paparppponegeri)
      this.disablesetpegawaiprosesan = false
      this.disablesetpegawaioperasi = false
      this.setpegawaiprosesan = ''
      this.setpegawaioperasi = ''
    },
    async tutuppppomodal(){
      this.$router.push(`/${i18n.locale}/paparanutama`)
    },
    async semakpppo() {
      try {
        // const hasilsemakpppo = await axios.get(`${process.env.VUE_APP_API_URL}/pppo/semakpppo`)
        if(this.$route.path === `/${i18n.locale}/tetapkanpenyeliaprosesanoperasi`){
          this.paparbtntutup = false
        } else {
          this.paparbtntutup = true
        }
        if (localStorageData.pp() !== null) {
          this.setpegawaiprosesan = localStorageData.pp().ppid
          console.log(this.setpegawaiprosesan)
        }
        if (localStorageData.po() !== null) {
          this.setpegawaioperasi = localStorageData.po().poid
        }
      } catch (err) {
        alert(err);
      }
    },
    async senaraipppo(ng) {
      const senaraipppo = await axios.post(
        `${process.env.VUE_APP_API_URL}/pppo/senaraipppo`,{
          negeri:ng
        }
      );
      const senaraipp = [];
      const senaraipo = [];
      senaraipppo.data.senaraipppo.forEach(async function (element) {
        if (element.peranan === "PP") {
          senaraipp.push({
            id: `${element.idpengguna}`,
            nama: `${element.email} - ${element.name}`,
            disabled: element.Statusakaun === "Disable" ? true : false,
          });
        }
        if (element.peranan === "PO") {
          senaraipo.push({
            id: `${element.idpengguna}`,
            nama: `${element.email} - ${element.name}`,
            disabled: element.Statusakaun === "Disable" ? true : false,
          });
        }
      });
      this.senaraipegawaipp = senaraipp;
      this.senaraipegawaipo = senaraipo;
    },
    async hantarpppo() {
      try {
        if (this.$refs.formtetapkanpppo.validate()) {
          const setpegawai = {
            setpp: this.setpegawaiprosesan,
            setpo: this.setpegawaioperasi,
          };
          await axios
            .post(
              `${process.env.VUE_APP_API_URL}/pppo/tetapkanpenyeliaprosesanoperasi`,
              setpegawai
            )
            .then((res) => {
              if(this.peranan.role === 'ADMIN'){
                let user = JSON.parse(window.localStorage.getItem('user'))
                const datauser = {
                    "id":user.id,
                    "name":user.name,
                    "role":user.role,
                    "kodneg": this.paparppponegeri,
                    "kaw":user.kaw,
                    "NoTac": user.NoTac
                  }
                window.localStorage.setItem('user', JSON.stringify(datauser))
              }
              window.localStorage.setItem(
                "datapp",
                JSON.stringify(res.data.datapp)
              );
              window.localStorage.setItem(
                "datapo",
                JSON.stringify(res.data.datapo)
              );
            });
          this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
                icon: "check_circle",
              };
          if(this.$route.path !== `/${i18n.locale}/tetapkanpenyeliaprosesanoperasi`){
            this.$router.go()
          }
        }
      } catch (err) {
        alert(err);
      }
    },
  },
  watch: {},
};
</script>